<template>
    <a-spin :spinning="spinning" tip="Loading...">
        <div class="card mb-3">
            <div class="row no-gutters">
                <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                    <div class="card-body">

                        <div class="row">
                            <div class="col-md-4">
                                <base-input label="Points">
                                    <select class="form-control" v-model="inputPoints">
                                        <option v-for="option in pointsOptions" :value="option.key" :key="option.key">
                                            {{ option.value }}
                                        </option>
                                    </select>
                                </base-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <base-input label="Status">
                                    <select class="form-control" v-model="inputStatus">
                                        <option v-for="option in statusOptions" :value="option.key" :key="option.key">
                                            {{ option.value }}
                                        </option>
                                    </select>
                                </base-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <br>
                                <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                                <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;

                                <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="downloadCsv"> Download CSV </button> &nbsp; &nbsp;
                                <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateExcel"> Download Excel </button> &nbsp; &nbsp;
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import * as ExcelJS from "exceljs";

    import {
        mapState,
        mapActions
    } from 'vuex'

    var component_x;

    export default {
        components: {
        },
        props: ['access_rights'],
        data() {
            return {
                spinning: false,
                inputPoints: 'All',
                inputStatus: 'All',
                pointsOptions: [
                    {key: 'All', value: 'All'},
                    {key: 'Positive', value: 'Positive'},
                    {key: '0', value: '0'},
                    {key: 'Negative', value: 'Negative'},
                ],
                statusOptions: [
                    {key: 'All', value: 'All'},
                    {key: 'Active', value: 'Active'},
                    {key: 'Inactive', value: 'Inactive'},
                ],
                currDate: moment().format("L_LT").split(":").join(";"),
                JsonData: []
            }
        },
        mounted: async function () {
            component_x = this;
        },
        computed: {
            ...mapState(['currentProfile', 'endPoint']),
        },
        methods: {
            moment,
            convertToCurrency(num) {
                return Number(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            generateReport: async function () {
                this.spinning = true;

                let parameters = {
                    "points": this.inputPoints,
                    "status": this.inputStatus
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'clp_customer_points_report?', parameters);

                if (get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    this.spinning = false;
                    return;
                }

                if (get_request.length > 0) {
                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    let reportLogo = document.getElementById('reportLogo');
                    try {
                        if (reportLogo && reportLogo.naturalWidth > 0) {
                            doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                        }
                    } catch (e) {
                        console.warn('Could not add report logo to PDF:', e);
                    }

                    let headers = [
                        [
                            {content: 'Customer Name', styles: {halign: 'center'}},
                            {content: 'Customer Code', styles: {halign: 'center'}},
                            {content: 'Card Type', styles: {halign: 'center'}},
                            {content: 'Address', styles: {halign: 'center'}},
                            {content: 'Last Transaction Date', styles: {halign: 'center'}},
                            {content: 'Points', styles: {halign: 'center'}},
                        ]
                    ];

                    let filter_header = `Points: ${this.inputPoints} | Status: ${this.inputStatus}`;

                    for (let x = 0; x < get_request.length; x++) {
                        let reportDetails = get_request[x].report_details;

                        if (x > 0 && reportDetails.length > 0) {
                            doc.addPage();
                        }

                        let reportData = [];
                        if (reportDetails.length > 0) {
                            for (let i = 0; i < reportDetails.length; i++) {
                                let line = reportDetails[i];
                                reportData.push([
                                    line.customer_name,
                                    line.customer_code,
                                    line.card_type,
                                    line.address || '',
                                    line.last_transaction_date,
                                    Number(line.points || 0).toFixed(2)
                                ]);
                            }
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15, 20, "CLP Customer List w/ Points Report");
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        doc.text(15, 25, filter_header);

                        doc.autoTable({
                            startY: 35,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'auto',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            margin: { bottom: 30 },
                            styles: {
                                cellPadding: 1.3, fontSize: 10,
                            },
                            columnStyles: {
                                0: {cellWidth: 'auto', halign: 'left'},
                                1: {cellWidth: 'auto', halign: 'left'},
                                2: {cellWidth: 'auto', halign: 'left'},
                                3: {cellWidth: 'auto', halign: 'left'},
                                4: {cellWidth: 'auto', halign: 'center'},
                                5: {cellWidth: 'auto', halign: 'right'},
                            }
                        });
                    }

                    let printed_by = secureStorage.getItem("email") || '';
                    let pageCount = doc.internal.getNumberOfPages();
                    for (let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "CLP Customer List w/ Points Report", 330, 200, i, pageCount);
                    }
                    doc.save(`CLPCustomerPointsReport_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'No data found. Try adjusting the filters.');
                }
                this.spinning = false;
            },
            generateFile: async function () {
                this.spinning = true;

                let parameters = {
                    "points": this.inputPoints,
                    "status": this.inputStatus
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'clp_customer_points_report?', parameters);

                if (get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    this.spinning = false;
                    return;
                }

                if (get_request.length > 0) {
                    let headers = ["Customer Name", "Customer Code", "Card Type", "Address", "Last Transaction Date", "Points"];
                    let site_specific = [];

                    for (let x = 0; x < get_request.length; x++) {
                        let reportDetails = get_request[x].report_details;
                        let reportData = [];

                        if (reportDetails.length > 0) {
                            for (let i = 0; i < reportDetails.length; i++) {
                                let line = reportDetails[i];
                                reportData.push([
                                    line.customer_name,
                                    line.customer_code,
                                    line.card_type,
                                    line.address || '',
                                    line.last_transaction_date,
                                    line.points
                                ]);
                            }
                        }

                        let keys = headers;
                        let values = reportData;
                        let newJsonData = [];

                        for (var i = 0; i < values.length; i++) {
                            var result = Object.assign.apply({}, keys.map((val, index) => ({
                                [val]: values[i][index]
                            })));
                            newJsonData.push(result);
                        }

                        newJsonData.forEach(function(obj) {
                            for (var i in obj) {
                                if (obj[i] === undefined || obj[i] === null) {
                                    obj[i] = '';
                                }
                            }
                        });
                        site_specific.push(newJsonData);
                    }
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'No data found.');
                }
                this.spinning = false;
            },
            downloadCsv() {
                if (this.JsonData.length === 0) return;
                const headers = Object.keys(this.JsonData[0]);
                const csvRows = [headers.join(',')];
                this.JsonData.forEach(row => {
                    const values = headers.map(h => {
                        const val = (row[h] === null || row[h] === undefined) ? '' : row[h];
                        return `"${String(val).replace(/"/g, '""')}"`;
                    });
                    csvRows.push(values.join(','));
                });
                const csvContent = csvRows.join('\n');
                const encodedUri = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent);
                const link = document.createElement('a');
                link.setAttribute('href', encodedUri);
                link.setAttribute('download', `CLP-Customer-Points-${moment().format('YYYYMMDD_HHmmss')}.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.JsonData = [];
            },
            async generateExcel() {
                const workbook = new ExcelJS.Workbook();
                workbook.created = new Date();
                workbook.modified = new Date();
                const sheet = workbook.addWorksheet("CLP Customer Points", {
                    pageSetup: { paperSize: 9 }
                });

                let filter_header = `Points: ${this.inputPoints} | Status: ${this.inputStatus}`;

                const data_starts_at_row = 6;

                let reportLogo = document.getElementById('reportLogo');
                const base64Image = reportUtils.csvxlsxTools.getBase64Image(reportLogo);
                const imageId = workbook.addImage({
                    base64: base64Image,
                    extension: 'png',
                });
                sheet.addImage(imageId, {
                    tl: { col: 0, row: 0 },
                    ext: { width: 61, height: 61 }
                });

                sheet.getRow(4).values = ['CLP Customer List w/ Points Report'];
                sheet.getRow(5).values = [`Filtered by: ${filter_header}`];

                sheet.getRow(data_starts_at_row).values = ["Customer Name", "Customer Code", "Card Type", "Address", "Last Transaction Date", "Points"];
                sheet.columns = [
                    { key: "customer_name", width: 25 },
                    { key: "customer_code", width: 18 },
                    { key: "card_type", width: 15 },
                    { key: "address", width: 30 },
                    { key: "last_transaction_date", width: 20 },
                    { key: "points", width: 12 },
                ];

                var report_details = this.JsonData;
                var rowDatas = [];

                for (let i = 0; i < report_details.length; i++) {
                    const rd = report_details[i];
                    rowDatas.push({
                        customer_name: rd["Customer Name"],
                        customer_code: rd["Customer Code"],
                        card_type: rd["Card Type"],
                        address: rd["Address"],
                        last_transaction_date: rd["Last Transaction Date"],
                        points: rd["Points"]
                    });
                }

                sheet.addRows(rowDatas);

                sheet.getRow(4).font = { bold: true, size: 16 };
                sheet.getRow(4).height = 20;
                sheet.getRow(data_starts_at_row).font = { bold: true };

                sheet.eachRow(function (Row, rowNum) {
                    if (rowNum >= data_starts_at_row) {
                        Row.eachCell(function (Cell, cellNum) {
                            if (rowNum == data_starts_at_row) {
                                Cell.alignment = { horizontal: 'center' };
                            } else {
                                Cell.alignment = { vertical: 'middle', horizontal: 'left' };
                            }
                        });
                    }
                });

                workbook.xlsx.writeBuffer().then(function(buffer) {
                    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                    const reader = new FileReader();
                    reader.onload = function() {
                        const link = document.createElement('a');
                        link.setAttribute('href', reader.result);
                        link.setAttribute('download', 'CLPCustomerPointsReport.xlsx');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    };
                    reader.readAsDataURL(blob);
                });
                this.JsonData = [];
            }
        }
    };
</script>

<style></style>
